<template>
<footer v-if="!getSubRouter" class="footer-section bg-success" style="padding: 40px 0;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-3 text-center">
                <h4>SÍGUENOS EN</h4>
            </div>
            <div class="col-sm-12 col-md-9">
                <div class="row">
                    <div class="col">
                        <div class="box-socials d-flex">
                            <div class="box-icon mr-2 pt-2">
                                <a href="https://www.instagram.com/limaserpar">
                                    <img src="https://www.serpar.gob.pe/wp-content/uploads/2019/02/in_50x50.png" width="40px" />
                                </a>
                            </div>
                            <div class="box-content text-white">
                                <span>Instagram</span>
                                <h5 class="m-0">
                                    <a class="text-white" href="https://www.instagram.com/limaserpar" target="_blank">@LimaSerpar</a>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="box-socials d-flex">
                            <div class="box-icon mr-2 pt-2">
                                <a href="https://www.facebook.com/limaserpar">
                                    <img src="https://www.serpar.gob.pe/wp-content/uploads/2019/02/fb_50x50.png" width="40px" />
                                </a>
                            </div>
                            <div class="box-content text-white">
                                <span>Facebook</span>
                                <h5 class="m-0">
                                    <a class="text-white" href="https://www.facebook.com/limaserpar" target="_blank">/LimaSerpar</a>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="box-socials d-flex">
                            <div class="box-icon mr-2 pt-2">
                                <a href="https://www.twitter.com/limaserpar">
                                    <img src="https://www.serpar.gob.pe/wp-content/uploads/2019/02/tw_50x50.png" width="40px" />
                                </a>
                            </div>
                            <div class="box-content text-white">
                                <span>Twitter</span>
                                <h5 class="m-0">
                                    <a class="text-white" href="https://www.twitter.com/limaserpar" target="_blank">@LimaSerpar</a>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="box-socials d-flex">
                            <div class="box-icon mr-2 pt-2">
                                <a href="https://www.twitter.com/limaserpar">
                                    <img src="https://www.serpar.gob.pe/wp-content/uploads/2022/11/icons8-tik-tok-50.png" width="45px" />
                                </a>
                            </div>
                            <div class="box-content text-white">
                                <span>TikTok</span>
                                <h5 class="m-0">
                                    <a class="text-white" href="https://www.linkedin.com/company/limaserpar/" target="_blank">@LimaSerpar</a>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters(['getSubRouter'])

    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/MainFooter.vue